/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdWebFeaturesStoreContinueRedirectWithPiRequest interface.
 */
export function instanceOfFxIdWebFeaturesStoreContinueRedirectWithPiRequest(value) {
    if (!('OrderPublicId' in value) || value['OrderPublicId'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesStoreContinueRedirectWithPiRequestFromJSON(json) {
    return FxIdWebFeaturesStoreContinueRedirectWithPiRequestFromJSONTyped(json, false);
}
export function FxIdWebFeaturesStoreContinueRedirectWithPiRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'OrderPublicId': json['OrderPublicId'],
        'PIEmail': json['PIEmail'] == null ? undefined : json['PIEmail'],
        'PIPhoneNumber': json['PIPhoneNumber'] == null ? undefined : json['PIPhoneNumber'],
        'AutoConfirm': json['AutoConfirm'] == null ? undefined : json['AutoConfirm'],
    };
}
export function FxIdWebFeaturesStoreContinueRedirectWithPiRequestToJSON(json) {
    return FxIdWebFeaturesStoreContinueRedirectWithPiRequestToJSONTyped(json, false);
}
export function FxIdWebFeaturesStoreContinueRedirectWithPiRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'OrderPublicId': value['OrderPublicId'],
        'PIEmail': value['PIEmail'],
        'PIPhoneNumber': value['PIPhoneNumber'],
        'AutoConfirm': value['AutoConfirm'],
    };
}
//# sourceMappingURL=FxIdWebFeaturesStoreContinueRedirectWithPiRequest.js.map